import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './edu_v2/Header';
import Footer from './edu_v2/Footer';
import Home from './edu_v2/Home';
import Cohort from './edu_v2/Cohort';
import Syllabus from './edu_v2/Syllabus';
import Apply from './edu_v2/Apply';

export default function EducationTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F5EFE0]" data-testid="lum-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`lum-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'cohort' && <Cohort setPage={setPage} />}
          {page === 'syllabus' && <Syllabus setPage={setPage} />}
          {page === 'apply' && <Apply setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
